import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import React, { useCallback } from "react";
import { Form } from "react-bootstrap";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

import { DATE_SELECTION_TYPE, EXTRA_TYPE } from "../../witadmin/Common/constants";

import {
  StyledGrid,
  StyledRow,
  StyledCol,
  StyledTitleExtra,
  StyledDescriptionExtra,
  StyledTextEnjoy,
  StyledTypeExtra,
  StyledValueExtra,
  StyledDropdown,
  StyledDropdownItem,
  StyledDropdownMenu,
  StyledDropdownToggle,
  StyledFontAwesomeIcon,
} from "../styled";

import { getValuesByNumber } from "../utils";
import { format } from "date-fns";
import { es } from "date-fns/locale";

const messages = {
  ...defineMessages({
    person: {
      id: "quotation.extra.person",
      defaultMessage: "persona",
    },
    room: {
      id: "quotation.extra.room",
      defaultMessage: "habitación",
    },
    date: {
      id: "quotation.extra.date",
      defaultMessage: "fecha",
    },
    day: {
      id: "quotation.extra.day",
      defaultMessage: "día",
    },
    unit: {
      id: "quotation.extra.unit",
      defaultMessage: "unidad",
    },
    textEnjoy: {
      id: "quotation.extra.textEnjoy",
      defaultMessage: "Seleccionar días de estancia",
    },
    textEnjoyDate: {
      id: "quotation.extra.textEnjoyDate",
      defaultMessage: "Unidades a disfrutar por día de estancia",
    },
    include: {
      id: "quotation.extra.include",
      defaultMessage: "Incluido",
    },
  }),
};

const BasicSelect = ({ options, onChange, title = "-", width = "100%" }: any) => {
  return (
    <StyledDropdown width={width}>
      <StyledDropdownToggle>
        {title}
        {<StyledFontAwesomeIcon icon={faChevronDown} />}
      </StyledDropdownToggle>

      <StyledDropdownMenu>
        {options.map((option: any) => (
          <StyledDropdownItem
            onClick={() => {
              onChange(option);
            }}>
            {option.label}
          </StyledDropdownItem>
        ))}
      </StyledDropdownMenu>
    </StyledDropdown>
  );
};

const RoomOrPersonDateSpecific = ({
  dateSelectionType,
  type,
  obligatory,
  open,
  listDate,
  ticker,
  changeValueDate,
  indexExtraRoom,
  isDateChecked,
}: any) => {
  return (
    <div>
      {((dateSelectionType === DATE_SELECTION_TYPE.SPECIFIC && type === EXTRA_TYPE.PERSON) ||
        (dateSelectionType === DATE_SELECTION_TYPE.SPECIFIC && type === EXTRA_TYPE.ROOM)) &&
        !obligatory &&
        open && (
          <StyledRow>
            <StyledCol xs={12}>
              <StyledTextEnjoy>
                <FormattedMessage {...messages.textEnjoy} />
              </StyledTextEnjoy>
            </StyledCol>
            {listDate.map((day: any) => (
              <StyledCol xs={3} padding="8px" key={day}>
                <Form style={{ width: "100%" }}>
                  <Form.Check
                    type={"checkbox"}
                    id={`check-extra-checkbox`}
                    style={{ paddingLeft: "0px" }}>
                    <Form.Check.Label>
                      <StyledTypeExtra>
                        {format(new Date(day), "EEEEEE-dd-MMM", {
                          locale: es,
                        }).toLocaleUpperCase()}
                      </StyledTypeExtra>
                    </Form.Check.Label>
                    <Form.Check.Input
                      style={{ marginLeft: "12px" }}
                      name={`checkbox-${ticker}`}
                      type={"checkbox"}
                      onChange={(value: any) => {
                        changeValueDate(indexExtraRoom, day);
                      }}
                      checked={isDateChecked(indexExtraRoom, day)}
                    />
                  </Form.Check>
                </Form>
              </StyledCol>
            ))}
          </StyledRow>
        )}
    </div>
  );
};

const UnitDateSpecific = ({
  dateSelectionType,
  type,
  obligatory,
  open,
  listDate,
  changeValueDate,
  indexExtraRoom,
  getValueDate,
  maxUnits,
}: any) => {
  return (
    <div>
      {dateSelectionType === DATE_SELECTION_TYPE.SPECIFIC &&
        type === EXTRA_TYPE.UNIT &&
        !obligatory &&
        open && (
          <StyledRow>
            <StyledCol xs={12}>
              <StyledTextEnjoy>
                <FormattedMessage {...messages.textEnjoyDate} />
              </StyledTextEnjoy>
            </StyledCol>
            {listDate.map((day: any) => (
              <StyledCol xs={3} padding="8px" key={day}>
                <StyledTypeExtra>
                  {format(new Date(day), "EEEEEE-dd-MMM", {
                    locale: es,
                  }).toLocaleUpperCase()}
                </StyledTypeExtra>
                <div style={{ paddingLeft: "12px", minWidth: "72px" }}>
                  <BasicSelect
                    onChange={(value: any) => {
                      changeValueDate(indexExtraRoom, day, value);
                    }}
                    title={getValueDate(indexExtraRoom, day)}
                    options={getValuesByNumber(maxUnits)}
                  />
                </div>
              </StyledCol>
            ))}
          </StyledRow>
        )}
    </div>
  );
};

const DateNoneOrALLAndType = ({
  dateSelectionType,
  type,
  changeValueDate,
  indexExtraRoom,
  getValueDate,
  maxUnits,
  changeValueOpen,
  obligatory,
  open,
}: any) => {
  return (
    <div>
      {
        <StyledCol xs={12} justifyContent="center">
          {(dateSelectionType === DATE_SELECTION_TYPE.NONE ||
            dateSelectionType === DATE_SELECTION_TYPE.ALL) &&
          type === EXTRA_TYPE.UNIT ? (
            <BasicSelect
              width={"50px"}
              onChange={(value: any) => {
                changeValueDate(indexExtraRoom, "unit", value);
              }}
              title={getValueDate(indexExtraRoom, "unit")}
              options={getValuesByNumber(maxUnits)}
            />
          ) : (
            <Form>
              <Form.Check type={"checkbox"} id={`check-api-checkbox`}>
                <Form.Check.Input
                  name="group1"
                  type={"checkbox"}
                  onChange={(value: any) => {
                    changeValueOpen(indexExtraRoom, value.target.checked);
                  }}
                  checked={obligatory ? obligatory : open}
                  disabled={obligatory}
                />
              </Form.Check>
            </Form>
          )}
        </StyledCol>
      }
    </div>
  );
};

export const CardExtra = ({
  ratioCurrency,
  extra,
  listDate,
  dataExtraRoom,
  setDataExtrasRoom,
  indexExtraRoom,
  currency,
}: any) => {
  const {
    ticker,
    name,
    description,
    maxUnits,
    dateSelectionType,
    type,
    ariValue,
    open,
    obligatory,
  } = extra;

  const intl = useIntl();

  const changeValueOpen = useCallback(
    (index: number, value: any) => {
      const newDataExtrasRoom = [...dataExtraRoom];
      newDataExtrasRoom[index].open = value;
      setDataExtrasRoom(newDataExtrasRoom);
    },
    [dataExtraRoom, setDataExtrasRoom]
  );

  const changeValueDate = useCallback(
    (index: number, day: any, valueNumber: number = -1) => {
      const newDataExtrasRoom = [...dataExtraRoom];
      if (newDataExtrasRoom[index].list.some((listItem: any) => listItem.day === day)) {
        if (valueNumber === -1) {
          const indexValue = newDataExtrasRoom[index].list.findIndex(
            (listValue: any) => listValue.day === day
          );
          newDataExtrasRoom[index].list.splice(indexValue, 1);
        } else {
          const indexValue = newDataExtrasRoom[index].list.findIndex(
            (listValue: any) => listValue.day === day
          );
          newDataExtrasRoom[index].list[indexValue] = {
            day,
            value: valueNumber,
          };
        }
      } else {
        newDataExtrasRoom[index].list.push({ day, value: valueNumber === -1 ? 1 : valueNumber });
      }
      setDataExtrasRoom(newDataExtrasRoom);
    },
    [dataExtraRoom, setDataExtrasRoom]
  );

  const isDateChecked = (index: number, value: any) => {
    return dataExtraRoom?.[index]?.list?.some((listItem: any) => listItem.day === value);
  };

  const getValueDate = (index: number, value: any) => {
    const indexListValue = dataExtraRoom?.[index]?.list.findIndex(
      (listItem: any) => listItem.day === value
    );

    if (indexListValue > -1) {
      return dataExtraRoom?.[index]?.list?.[indexListValue]?.value?.label || "";
    }
    return "0";
  };

  const getLabel = (type: string, dateSelectionType: string) => {
    let message = "";
    switch (type) {
      case EXTRA_TYPE.PERSON:
        message = intl.formatMessage(messages.person);
        break;
      case EXTRA_TYPE.ROOM:
        message = intl.formatMessage(messages.room);
        break;
      case EXTRA_TYPE.UNIT:
        message = intl.formatMessage(messages.unit);
        break;
    }
    switch (dateSelectionType) {
      case DATE_SELECTION_TYPE.ALL:
        message += ` / ${intl.formatMessage(messages.day)}`;
        break;

      case DATE_SELECTION_TYPE.SPECIFIC:
        message += ` / ${intl.formatMessage(messages.date)}`;
        break;
    }
    return message.toLowerCase();
  };

  return (
    <div style={{ borderBottom: "1px solid #B3B3B3" }}>
      <StyledGrid padding={"20px"}>
        <StyledRow>
          <StyledCol xs={9}>
            <StyledGrid>
              <StyledRow>
                <StyledCol xs={12}>
                  <StyledTitleExtra>{name}</StyledTitleExtra>
                </StyledCol>
              </StyledRow>
              <StyledRow>
                <StyledCol xs={12}>
                  <StyledDescriptionExtra
                    dangerouslySetInnerHTML={{
                      __html: description,
                    }}></StyledDescriptionExtra>
                </StyledCol>
              </StyledRow>

              <RoomOrPersonDateSpecific
                dateSelectionType={dateSelectionType}
                type={type}
                obligatory={obligatory}
                open={open}
                listDate={listDate}
                ticker={ticker}
                changeValueDate={changeValueDate}
                indexExtraRoom={indexExtraRoom}
                isDateChecked={isDateChecked}
              />
              <UnitDateSpecific
                dateSelectionType={dateSelectionType}
                type={type}
                obligatory={obligatory}
                open={open}
                listDate={listDate}
                changeValueDate={changeValueDate}
                indexExtraRoom={indexExtraRoom}
                getValueDate={getValueDate}
                maxUnits={maxUnits}
              />
            </StyledGrid>
          </StyledCol>
          <StyledCol xs={3}>
            <StyledGrid>
              <StyledRow>
                <StyledCol xs={12} justifyContent="center">
                  <StyledValueExtra>
                    {obligatory
                      ? intl.formatMessage(messages.include)
                      : `${currency} ${(ariValue?.totalRate * ratioCurrency).toFixed(2)}`}
                  </StyledValueExtra>
                </StyledCol>
              </StyledRow>
              <StyledRow>
                <StyledCol xs={12} justifyContent="center">
                  <StyledTypeExtra>
                    {obligatory ? "" : getLabel(type, dateSelectionType)}
                  </StyledTypeExtra>
                </StyledCol>
                <StyledCol xs={12} justifyContent="center">
                  <StyledTypeExtra>
                    <DateNoneOrALLAndType
                      dateSelectionType={dateSelectionType}
                      type={type}
                      changeValueDate={changeValueDate}
                      indexExtraRoom={indexExtraRoom}
                      getValueDate={getValueDate}
                      maxUnits={maxUnits}
                      changeValueOpen={changeValueOpen}
                      obligatory={obligatory}
                      open={open}
                    />
                  </StyledTypeExtra>
                </StyledCol>
              </StyledRow>
            </StyledGrid>
          </StyledCol>
        </StyledRow>
      </StyledGrid>
    </div>
  );
};
